'use client';

import { SIZE } from '@constants';
import { Box } from '@viewup/ui';
import { useIsBottomBarVisible } from 'app/_hook';

interface WrapperStyledProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

export const WrapperStyled = ({ children }: WrapperStyledProps) => {
  const isBottomBarVisible = useIsBottomBarVisible();
  const defaultHeight = `calc(100svh - ${isBottomBarVisible ? SIZE.BOTTOM_BAR_HEIGHT : 0}px - ${SIZE.HEADER_HEIGHT}px - env(safe-area-inset-bottom))`;
  return (
    <Box
      className='wrapper'
      css={{
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        height: defaultHeight,
        minHeight: defaultHeight,
        overflow: 'auto',
        overflowX: 'hidden',
      }}
      maxWidth={440}
      position='relative'
      width='100%'
    >
      {children}
    </Box>
  );
};
